import React from "react";
import { MapPin } from "lucide-react";

const TILE = 256;
const toWorld = (lat, lon, z) => {
  const n = TILE * 2 ** z;
  const r = (lat * Math.PI) / 180;
  return { x: ((lon + 180) / 360) * n, y: ((1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2) * n };
};

/** Vintage "atlas" mini map: OSM tiles composed around a point, sepia-toned, no map library needed. */
export const MiniMap = ({ lat, lon, zoom = 4, width = 260, height = 140, label, href, testid }) => {
  if (lat == null || lon == null) return null;
  const c = toWorld(lat, lon, zoom);
  const left = c.x - width / 2, top = c.y - height / 2;
  const max = 2 ** zoom;
  const tiles = [];
  for (let tx = Math.floor(left / TILE); tx <= Math.floor((left + width) / TILE); tx++) {
    for (let ty = Math.floor(top / TILE); ty <= Math.floor((top + height) / TILE); ty++) {
      if (ty < 0 || ty >= max) continue;
      tiles.push({ key: `${tx}-${ty}`, x: ((tx % max) + max) % max, y: ty, dx: tx * TILE - left, dy: ty * TILE - top });
    }
  }
  const map = (
    <div data-testid={testid} className="relative overflow-hidden rounded-lg ring-1 ring-ink/20 bg-[#e8dcc3]" style={{ width: "100%", aspectRatio: `${width} / ${height}` }} aria-label={label ? `Map of ${label}` : "Map"}>
      <div className="absolute inset-0" style={{ filter: "sepia(0.75) saturate(0.7) contrast(0.95) brightness(0.98)" }}>
        {tiles.map((t) => <img key={t.key} src={`https://tile.openstreetmap.org/${zoom}/${t.x}/${t.y}.png`} alt="" loading="lazy" draggable={false} className="absolute select-none" style={{ left: `${(t.dx / width) * 100}%`, top: `${(t.dy / height) * 100}%`, width: `${(TILE / width) * 100}%`, height: `${(TILE / height) * 100}%` }} />)}
      </div>
      <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: "inset 0 0 40px rgba(60,40,10,0.45)", backgroundImage: "radial-gradient(rgba(0,0,0,0.05) 1px, transparent 1px)", backgroundSize: "3px 3px" }} />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-full text-[#8b1a1a] drop-shadow"><MapPin className="w-6 h-6 fill-[#8b1a1a]/20" strokeWidth={2.5} /></div>
      {label && <span className="absolute left-2 bottom-1.5 max-w-[85%] truncate text-[10px] font-bold uppercase tracking-wider text-ink/80 bg-[#f3ead6]/85 px-1.5 py-0.5 rounded">{label}</span>}
      <span className="absolute right-1 bottom-1 text-[9px] font-medium text-ink/80 bg-[#f3ead6]/85 px-1 rounded">© OpenStreetMap contributors</span>
    </div>
  );
  return href ? <a href={href} target="_blank" rel="noopener noreferrer" className="block transition-transform duration-300 hover:-translate-y-0.5">{map}</a> : map;
};
